window.addEventListener('DOMContentLoaded', () => {
  const hamburger_menu = document.getElementById("hamburger_menu")
  const header_sp_menu_list_close_btn = document.getElementsByClassName("header-sp-menu-list__close-button")[0]
  const transparentLogo = document.getElementById("transparent-sp_logo")
  const normalLogo = document.querySelector(".header-sp__logo")
  const headerSp = document.querySelector('.header-sp')

  // r-kikaku画面は除外
  if (!headerSp) return

  let transparentClassName = ''
  if (headerSp.classList.contains('global_navigation_bk_transparent_font_white')) {
    transparentClassName = 'global_navigation_bk_transparent_font_white'
  } else if (headerSp.classList.contains('global_navigation_bk_transparent_font_black')) {
    transparentClassName = 'global_navigation_bk_transparent_font_black'
  }
  const hasHeaderTransparent = !!transparentClassName

  if (hamburger_menu) {
    const headerSpMenuList = document.querySelector(".header-sp-menu-list")
    const backgroundThemeColor = getComputedStyle(headerSpMenuList).backgroundColor
    hamburger_menu.addEventListener('click', () => {
      toggle()
      applyOpenMenuStyle(backgroundThemeColor)
    })
  }

  if (header_sp_menu_list_close_btn) {
    const topPage = document.getElementById("top/show") // トップ画面テンプレートのmetaに設定したIDを取得
    const areaPage = document.getElementById("areas/show") // エリア画面テンプレートのmetaに設定したIDを取得
    header_sp_menu_list_close_btn.addEventListener('click', () => {
      toggle()
      applyCloseMenuStyle(topPage, areaPage)
    });
  }

  const applyOpenMenuStyle = (backgroundThemeColor) => {
    hamburger_menu.style.display = "none"
    header_sp_menu_list_close_btn.style.display = "block"
    if (hasHeaderTransparent){
      headerSp.classList.remove(transparentClassName)
      headerSp.style.backgroundColor = backgroundThemeColor
      if(normalLogo){
        normalLogo.style.visibility = "unset"
        normalLogo.style.display = "block"
      }
      if(transparentLogo) {
        transparentLogo.style.visibility = "hidden"
        transparentLogo.style.display = "none"
      }
    }
  }

  const applyCloseMenuStyle = (topPage, areaPage) => {
    header_sp_menu_list_close_btn.style.display = "none"
    hamburger_menu.style.display = "block"
    if (hasHeaderTransparent){
      headerSp.classList.add(transparentClassName)
      if(normalLogo) normalLogo.style.display = ""
      // トップ画面またはエリア画面の場合
      if (topPage || areaPage) {
        if(normalLogo){
          normalLogo.style.visibility = "hidden"
          normalLogo.style.display = "none"
        }
        const globalNavPosition = document.querySelector(".mainvisual").getBoundingClientRect().bottom
        const headerHeight = document.querySelector(".header-sp").offsetHeight

        if(transparentLogo) {
          transparentLogo.style.display = "block"
        }

        // ヘッダーがグロナビまで届いていない場合、透過ロゴを表示
        if (globalNavPosition > headerHeight) {
          if(transparentLogo) {
            transparentLogo.style.display = "block"
            transparentLogo.style.visibility = "unset"
          }
        }else{
          if(normalLogo) normalLogo.style.visibility = "hidden"
        }
      }else{
        const scrollPosition = window.scrollY || window.pageYOffset
        // 画面最上部の場合は通常ロゴを表示、それ以外は非表示
        if (scrollPosition > 0) {
          if(normalLogo) normalLogo.style.visibility = "hidden"
        } else {
          if(normalLogo) normalLogo.style.visibility = "unset"
        }
      }
    }
  }

  const toggle = () => {
    document.getElementsByClassName("-invisible").length != 0 ? displayMenu() : hideMenu();
  }

  const displayMenu = () => {
    Array.from(document.getElementsByClassName("-invisible")).forEach(element => element.classList.remove("-invisible"));
  }

  const hideMenu = () => {
    document.getElementsByClassName("header-sp-background")[0].classList.add("-invisible");
    document.getElementsByClassName("header-sp-menu-list")[0].classList.add("-invisible");
  }

  const menuList = document.querySelectorAll(".header-sp-menu-list__menu")

  if(menuList && menuList.length > 0) {
    menuList.forEach(menu => {
      menu.addEventListener('click', () => {
        const subMenu = menu.nextElementSibling
        const childMenu = menu.querySelector(".header-sp-menu-list__menu__index")

        if (subMenu) {
          subMenu.classList.toggle("-is-open")
        }

        if (childMenu) {
          childMenu.classList.toggle("open")
        }
      })
    })
  }
})
